import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ChannelConfigStepper } from './ChannelConfigStepper';

import * as actions from '../actions/index'

/*global loginToSlack*/

export class SlackStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetchChannelProviders: PropTypes.func.isRequired,
    channelAPI: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    goBack: PropTypes.func.isRequired,
    addingChannel: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {}
    this.connect = this.connect.bind(this)
    this.getSlackData = this.getSlackData.bind(this)
    this.handleNextStep = this.handleNextStep.bind(this);
  }

  componentWillMount() {
    if (!this.props.channel) {
      const code = this.props.location.query.code
      const providerId = this.props.location.query.state

      //received providerId and code from Slack
      if (code && providerId) {
        //to hide the code and providerId from the addressbar
        const pathComponents = this.props.location.pathname.split("/");
        const path = pathComponents.join("/")
        this.context.router.push(path);

        this.setState({providerId:providerId, code:code})
        this.getSlackData(providerId, code)
      }
      else if (this.props.addingChannel) {
        this.props.fetchChannelProviders((response, err) => {
                            if (!err) {
                              if ( response.length !== 0 ) {
                                const providerId = response[0].id
                                const slackClientId = providerId.split("-")[1]
                                console.log("Got Slack Provider",slackClientId);
                                this.setState({providerId:providerId})
                              }
                              else {
                                this.props.dispatch(actions.setMessage("Provider Not Found"))
                              }
                            }
                          })
      }
    }
  }

  handleNextStep() {
    const { stepper } = this.channelConfigStepper
    const step = stepper.state.activeStep
    if (step === 1) {
      if (this.props.addingChannel) {
        this.connect()
      }
      else {
        this.nextStep()
      }
    }
    else if (step === 2) {
      if (this.props.addingChannel) {
        const { providerId, oauth } = this.state

        let newChannel = {enabled:true}
        newChannel.params = {
          "team_id":oauth.team_id,
          "token":oauth.bot.bot_access_token,
          "bot_user_id":oauth.bot.bot_user_id,
          "dispatcher_channel":"support"
        }
        newChannel.title = oauth.team_name
        newChannel.provider = providerId

        this.props.createChannel(newChannel, (response, err) => {
                               if (!err) {
                                this.nextStep()
                               }
                               })
      }
      else {
        this.props.goBack()
      }
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  render(){
    const { channel, channelType } = this.props
    return (
            <div>
            <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={channelType} channel={channel} onBeforeNextStep={this.handleNextStep}/>
            </div>
            )
  }

  // LOGIN

  connect() {
    const { providerId } = this.state
    if ( providerId !== undefined ) {
      const clientId = providerId.split("-")[1]
      const redirect_uri = window.location.href
      const state = providerId

      window.location.href = "https://slack.com/oauth/authorize?scope=channels:read,channels:write,chat:write:user,users:read,bot&client_id="+clientId+"&redirect_uri="+encodeURIComponent(redirect_uri)+"&state="+state;
    }
    else {
      this.props.dispatch(actions.setMessage("Provider Not Found"))
    }
  }

  getSlackData(providerId, code) {
    this.props.channelAPI(providerId, "oauth.access", {
                          redirect_uri: window.location.href,
                          code: code
                          }, (oauth, err) => {
                            if (!err) {
                              this.setState({oauth:oauth})
                              this.channelConfigStepper.stepper.setStep(2)
                            }
                            else {
                              console.log("Error",err)
                            }
                          })
  }

}



// WEBPACK FOOTER //
// ./src/containers/SlackStepper.js